import type { ReactNode } from 'react';

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  align?: 'left' | 'center';
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  action,
}: SectionHeadingProps) {
  const centered = align === 'center';
  return (
    <div
      className={`flex flex-col gap-4 ${
        centered ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between'
      }`}
    >
      <div className={centered ? 'max-w-2xl' : 'max-w-2xl'}>
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-[11px] tracking-[0.3em] text-primary-500 mb-3">
            <span className="w-6 h-px bg-primary-500 inline-block"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 leading-tight">
          {title}
        </h2>
        {description && (
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            {description}
          </p>
        )}
      </div>
      {action && <div className={centered ? 'mt-2' : 'shrink-0'}>{action}</div>}
    </div>
  );
}